import { customGoal, stage as trackEtStage } from "@flights/et-universal";
import { isOfMetaOrigin } from "./marketing-url-params.js";
export const trackMetaExperimentStage = (expName, stage) => {
    const isMeta = isOfMetaOrigin();
    if (isMeta) {
        trackEtStage(expName, stage);
    }
};
export const trackMetaCustomGoal = (expName, goal) => {
    const isMeta = isOfMetaOrigin();
    if (isMeta) {
        customGoal(expName, goal);
    }
};
